var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "polygon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.28,
    height: 13.979,
    viewBox: "0 0 16.28 13.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 16.28,
    height: 13.979,
    fill: "#5b5b5b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_110",
    "data-name": "Caminho 110",
    d: "M1.068,11.151V7.934A7.007,7.007,0,0,1,2.75,3.373l.046-.05A6.993,6.993,0,0,1,4.638,1.81H.39a.394.394,0,0,1-.39-.4.385.385,0,0,1,.39-.381H6.646l.073-.018V.39A.392.392,0,0,1,7.1,0H9.166a.389.389,0,0,1,.389.39v.624l.074.018h6.256a.386.386,0,0,1,.394.381.4.4,0,0,1-.394.4H11.637A6.8,6.8,0,0,1,13.52,3.373a7.036,7.036,0,0,1,1.7,4.561v3.217h.375a.389.389,0,0,1,.395.385V13.6a.389.389,0,0,1-.395.381H13.539a.387.387,0,0,1-.389-.381V11.536a.388.388,0,0,1,.389-.385h.381V7.934a5.793,5.793,0,0,0-4.364-5.6v.11a.389.389,0,0,1-.389.39H7.1a.392.392,0,0,1-.386-.39v-.11A5.881,5.881,0,0,0,3.758,4.161l-.018.033a5.766,5.766,0,0,0-1.384,3.74v3.217h.385a.384.384,0,0,1,.386.385V13.6a.384.384,0,0,1-.386.381H.679A.384.384,0,0,1,.293,13.6V11.536a.385.385,0,0,1,.386-.385h.39Zm14.139.77H13.924v1.288h1.284Zm-12.852,0H1.068v1.288H2.356ZM8.777.775H7.5V2.057H8.777V.775Z",
    transform: "translate(0 0)",
    fill: "#5b5b5b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.369396ecbf8d135a825e2bdd627245ee.svg";
export { ForwardRef as ReactComponent };